export default __webpack_public_path__ + "static/media/md-saif-ahmed.b832ef84.jpg";